// This is a client to talk to cloud functions
import axios from 'axios';
import {firebase} from './firebase';

const baseUrl = process.env.REACT_APP_FIREBASE_FUNCTIONS_URL;

const CloudFunctionsClient = axios.create({
  baseURL: baseUrl,
});

firebase.auth().onIdTokenChanged(async (user) => {
  if (user) {
    const idToken = await user.getIdToken();
    const authHeader = `Bearer ${idToken}`
    CloudFunctionsClient.defaults.headers.common['Authorization'] = authHeader;
  }
});


export {CloudFunctionsClient};



// WEBPACK FOOTER //
// ./src/CloudFunctionsClient.js